import React, { useState } from "react";
import { useContent } from "../context/ContentProvider";

const ContactUs: React.FC = () => {
  const { content } = useContent();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Here you would typically send the form data to your backend
      console.log("Contact form submitted:", formData);

      // Simulate API call
      await new Promise((resolve) => setTimeout(resolve, 1000));

      // Reset form after successful submission
      setFormData({ name: "", email: "", message: "" });
      alert("Message envoyé avec succès! Nous vous répondrons bientôt.");
    } catch (error) {
      console.error("Error submitting contact form:", error);
      alert("Une erreur est survenue. Veuillez réessayer.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={{ backgroundColor: "var(--hotel-background-color)" }}>
      <div className="min-h-screen flex">
        {/* Left Section - Image */}
        <div className="w-1/2 relative">
          <div
            className="h-full w-full bg-cover bg-center"
            style={{ backgroundImage: "url('/contact-us.webp')" }}
            aria-label="Contact"
          />
          <div className="absolute inset-0 bg-black/20 pointer-events-none" />
        </div>

        {/* Right Section - Contact Form */}
        <div
          className="w-1/2 px-12 py-16 flex items-center"
          style={{
            backgroundColor: "var(--hotel-card-background-color)",
            color: "var(--hotel-text-color)",
          }}
        >
          <div className="w-full max-w-lg">
            {/* Title */}
            <h1
              className="text-3xl md:text-4xl font-bold mb-6"
              style={{
                fontFamily: "var(--hotel-heading-font-family)",
                color: "var(--hotel-primary-color)",
              }}
            >
              {content.contactTitle || "Réservez votre séjour"}
            </h1>

            {/* Description */}
            <p
              className="text-base mb-8 leading-relaxed"
              style={{
                fontFamily: "var(--hotel-body-font-family)",
                color: "var(--hotel-text-color)",
              }}
            >
              {content.contactDescription ||
                "Pour toute réservation ou question, veuillez remplir ce formulaire afin de nous envoyer un message. Nous vous répondrons dans les plus brefs délais."}
            </p>

            {/* Contact Form */}
            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Name Field */}
              <div>
                <label
                  htmlFor="name"
                  className="block text-sm font-medium mb-2 uppercase tracking-wide"
                  style={{
                    fontFamily: "var(--hotel-heading-font-family)",
                    color: "var(--hotel-text-color)",
                  }}
                >
                  {content.contactNameLabel || "NOM"}
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder={
                    content.contactNamePlaceholder ||
                    "Entrez votre Prénom et Nom"
                  }
                  required
                  className="w-full py-3 px-0 bg-transparent border-0 border-b-2 focus:outline-none focus:ring-0 transition-colors duration-200"
                  style={{
                    fontFamily: "var(--hotel-body-font-family)",
                    color: "var(--hotel-text-color)",
                    borderBottomColor: "var(--hotel-text-color)",
                  }}
                />
              </div>

              {/* Email Field */}
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium mb-2 uppercase tracking-wide"
                  style={{
                    fontFamily: "var(--hotel-heading-font-family)",
                    color: "var(--hotel-text-color)",
                  }}
                >
                  {content.contactEmailLabel || "EMAIL"}
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder={
                    content.contactEmailPlaceholder || "Entrez votre email"
                  }
                  required
                  className="w-full py-3 px-0 bg-transparent border-0 border-b-2 focus:outline-none focus:ring-0 transition-colors duration-200"
                  style={{
                    fontFamily: "var(--hotel-body-font-family)",
                    color: "var(--hotel-text-color)",
                    borderBottomColor: "var(--hotel-text-color)",
                  }}
                />
              </div>

              {/* Message Field */}
              <div>
                <label
                  htmlFor="message"
                  className="block text-sm font-medium mb-2 uppercase tracking-wide"
                  style={{
                    fontFamily: "var(--hotel-heading-font-family)",
                    color: "var(--hotel-text-color)",
                  }}
                >
                  {content.contactMessageLabel || "MESSAGE"}
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  placeholder={
                    content.contactMessagePlaceholder || "Votre message"
                  }
                  required
                  rows={4}
                  className="w-full py-3 px-0 bg-transparent border-0 border-b-2 focus:outline-none focus:ring-0 transition-colors duration-200 resize-y"
                  style={{
                    fontFamily: "var(--hotel-body-font-family)",
                    color: "var(--hotel-text-color)",
                    borderBottomColor: "var(--hotel-text-color)",
                  }}
                />
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full py-4 px-6 text-white font-bold uppercase tracking-wide transition-all duration-200 hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed"
                style={{
                  fontFamily: "var(--hotel-heading-font-family)",
                  backgroundColor: "var(--hotel-primary-color)",
                  color: "white",
                }}
              >
                {isSubmitting
                  ? content.contactSubmittingText || "ENVOI EN COURS..."
                  : content.contactSubmitText || "ENVOYER MESSAGE"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
